module.exports = __webpack_public_path__ + "img/14.a387e86c.jpg";